import { img1, img2,  img3,  img4,  img5,  img6,  img7,  img8,  img9,  img10,  img11} from "../assets";

const gallery = [
    {
        image: img1,
        decs: "HSL Team",
    }, 
    {
        image: img2,
        decs: "HSL Team",
    },
    {
        image: img3,
        decs: "HSL Team",
    }, 
    {
        image: img4,
        decs: "HSL Team",
    },
    {
        image: img5,
        decs: "HSL Team",
    },
    {
        image: img6,
        decs: "HSL Team",
    },

    {
        image: img7,
        decs: "HSL Team",
    },
    {
        image: img8,
        decs: "HSL Team",
    },
    {
        image: img9,
        decs: "HSL Team",
    },
    {
        image: img10,
        decs: "HSL Team",
    },
    {
        image: img11,
        decs: "HSL Team",
    },

];
export default gallery;
